import type { PackingState } from "../domain/schema";

/** Kept in the existing local preferences store so an older trip parser cannot erase it. */
export const recipientCopyKey = (tripId: string) =>
	`focus8.recipient:${tripId}`;
export function recipientCopy(state: PackingState) {
	return {
		key: recipientCopyKey(state.trip.id),
		value: Object.fromEntries(
			state.items.map((item) => [item.id, item.recipientId ?? null]),
		),
	};
}
export function withPreservedRecipients(
	state: PackingState,
	copy: unknown,
): PackingState {
	if (!copy || typeof copy !== "object" || Array.isArray(copy)) return state;
	const values = copy as Record<string, unknown>;
	return {
		...state,
		items: state.items.map((item) => {
			// An explicit current field, including a deliberate clear, always wins.
			if (Object.hasOwn(item, "recipientId")) return item;
			const value = values[item.id];
			return typeof value === "string" &&
				value.length > 0 &&
				value.length <= 120
				? { ...item, recipientId: value }
				: item;
		}),
	};
}
